(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["search-cours"] && !Shopify.designMode) return;
  try {
    

(function () {

  class SearchCours {
    constructor(root) {
      this.root         = root;
      this.blogUrl      = root.dataset.blogUrl || '/blogs/cours';
      this.viewAll      = root.dataset.viewAll || 'Voir tous les résultats';
      this.input        = root.querySelector('[data-input]');
      this.clearBtn     = root.querySelector('[data-clear]');
      this.sugg         = root.querySelector('[data-suggestions]');
      this.backdrop     = document.createElement('div');
      this.backdrop.className = 'search-cours__backdrop';
      document.body.appendChild(this.backdrop);
      this.filters      = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
      this.pills        = root.querySelector('[data-pills]');
      this.activeRow    = root.querySelector('[data-active]');
      this.resetBtn     = root.querySelector('[data-reset]');
      this.triggerCount = root.querySelector('[data-active-count]');
      this.overlay      = root.querySelector('[data-overlay]');
      this.timer        = null;

      this._bindSearch();
      this._bindPanel();
      this._bindFilters();
      this._bindActions();
      this._hydrate();
      this._bindResize();

      // Sur mobile, les catégories sont déroulées par défaut (comme la maquette)
      if (this._isMobile()) {
        this.filters.forEach(function (f) {
          f.classList.add('is-open');
          var b = f.querySelector('[data-filter-btn]');
          if (b) b.setAttribute('aria-expanded', 'true');
        });
      }
    }

    _isMobile() { return window.matchMedia('(max-width: 749px)').matches; }

    /* ──────────────── Tiroir mobile ──────────────── */

    _bindPanel() {
      var self = this;
      Array.prototype.forEach.call(this.root.querySelectorAll('[data-open-panel]'), function (b) {
        b.addEventListener('click', function () { self._openPanel(); });
      });
      Array.prototype.forEach.call(this.root.querySelectorAll('[data-close-panel]'), function (b) {
        b.addEventListener('click', function () { self._closePanel(); });
      });
      if (this.overlay) this.overlay.addEventListener('click', function () {
        self._closePanel();
        self._submit();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self._closePanel();
      });
    }

    _openPanel() {
      this.root.classList.add('is-filters-open');
      document.body.style.overflow = 'hidden';
    }

    _closePanel() {
      this.root.classList.remove('is-filters-open');
      document.body.style.overflow = '';
    }

    /* ──────────────── Predictive search ──────────────── */

    _bindSearch() {
      var self = this;

      this.input.addEventListener('input', function () {
        var q = self.input.value.trim();
        self.clearBtn.hidden = !q;
        clearTimeout(self.timer);
        if (!q) { self._hideSugg(); return; }
        self.timer = setTimeout(function () { self._fetch(q); }, 250);
      });

      this.input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var q = self.input.value.trim();
          if (q) window.location.href = self._searchUrl(q);
        }
        if (e.key === 'Escape') self._hideSugg();
      });

      this.clearBtn.addEventListener('click', function () {
        self.input.value = '';
        self.clearBtn.hidden = true;
        self._hideSugg();
        self.input.focus();
      });

      document.addEventListener('click', function (e) {
        if (!self.root.contains(e.target)) self._hideSugg();
      });
    }

    _searchUrl(q) {
      return '/search?q=' + encodeURIComponent(q) + '&type=article&options[prefix]=last';
    }

    _fetch(q) {
      var self = this;
      var url  = '/search/suggest.json?q=' + encodeURIComponent(q)
               + '&resources[type]=article&resources[limit]=8'
               + '&resources[options][fields]=title';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var articles = (d.resources && d.resources.results && d.resources.results.articles) || [];
          self._renderSugg(articles, q);
        })
        .catch(function () { self._hideSugg(); });
    }

    _renderSugg(articles, q) {
      if (!articles.length) {
        this.sugg.innerHTML = '<p class="search-cours__suggestion-empty">Aucun résultat pour cette recherche.</p>';
        this.sugg.hidden = false;
        this.backdrop.classList.add('is-visible');
        return;
      }

      var cards = articles.map(function (a) {
        var img = a.image
          ? '<img src="' + a.image + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block;">'
          : '';
        return '<a href="' + a.url + '" class="blog-post-card-cours group">'
             + '<div class="blog-post-card-cours__image-wrapper overflow-hidden">'
             + img
             + '<div class="blog-post-card-cours__overlay">'
             + '<span class="h5 blog-post-card-cours__title">' + this._esc(a.title) + '</span>'
             + '</div></div></a>';
      }, this).join('');

      var html = '<div class="search-cours__suggestions-grid">' + cards + '</div>';

      if (articles.length >= 8) {
        html += '<a href="' + this._searchUrl(q) + '" class="search-cours__suggestion-more link">'
              + this._esc(this.viewAll) + '</a>';
      }

      this.sugg.innerHTML = html;
      this.sugg.hidden = false;
      this.backdrop.classList.add('is-visible');
    }

    _hideSugg() {
      this.sugg.hidden = true;
      this.sugg.innerHTML = '';
      this.backdrop.classList.remove('is-visible');
    }

    /* ──────────────── Filters ──────────────── */

    _bindFilters() {
      var self = this;

      this.filters.forEach(function (filter) {
        var btn = filter.querySelector('[data-filter-btn]');

        btn.addEventListener('click', function () {
          var open = filter.classList.contains('is-open');
          // Desktop : un seul dropdown ouvert. Mobile : accordéon indépendant.
          if (!self._isMobile()) self._closeAll();
          filter.classList.toggle('is-open', !open);
          btn.setAttribute('aria-expanded', String(!open));
        });

        /* sous-catégories : affichage seul, non cliquables */

        /* individual checkbox */
        Array.prototype.forEach.call(filter.querySelectorAll('[data-checkbox]'), function (cb) {
          cb.addEventListener('change', function () {
            // Sélection unique : on décoche les autres tags de ce filtre
            if (filter.dataset.selection === 'single' && cb.checked) {
              Array.prototype.forEach.call(filter.querySelectorAll('[data-checkbox]'), function (other) {
                if (other !== cb) other.checked = false;
              });
            }
            self._syncBadge(filter);
            self._syncPills();
          });
        });
      });

      // Desktop seulement : fermer les dropdowns au clic en dehors d'un filtre.
      document.addEventListener('click', function (e) {
        if (self._isMobile()) return;
        if (!e.target.closest('.search-cours__filter')) self._closeAll();
      });
    }

    _closeAll() {
      this.filters.forEach(function (f) {
        f.classList.remove('is-open');
        var btn = f.querySelector('[data-filter-btn]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    _syncBadge(filter) {
      var n     = filter.querySelectorAll('[data-checkbox]:checked').length;
      var badge = filter.querySelector('[data-badge]');
      if (!badge) return;
      badge.hidden      = n === 0;
      badge.textContent = n > 0 ? n : '';
    }

    _syncPills() {
      if (!this.pills) return;
      var self    = this;
      var checked = Array.prototype.slice.call(this.root.querySelectorAll('[data-checkbox]:checked'));

      if (this.activeRow) this.activeRow.hidden = checked.length === 0;
      if (this.resetBtn) this.resetBtn.hidden = checked.length === 0;
      if (this.triggerCount) {
        this.triggerCount.textContent = checked.length;
        this.triggerCount.hidden = checked.length === 0;
      }

      this.pills.innerHTML = checked.map(function (cb) {
        var label = cb.dataset.label || cb.value;
        return '<li class="search-cours__pill">'
             + self._esc(label)
             + '<button type="button" class="search-cours__pill-remove" data-remove="'
             + self._attr(cb.value) + '" aria-label="Retirer ' + self._attr(label) + '">×</button>'
             + '</li>';
      }).join('');

      Array.prototype.forEach.call(this.pills.querySelectorAll('[data-remove]'), function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.dataset.remove;
          var cb  = self.root.querySelector('[data-checkbox][value="' + self._attr(val) + '"]');
          if (cb) {
            cb.checked = false;
            var f = cb.closest('[data-filter]');
            if (f) self._syncBadge(f);
          }
          // Sur une page /tagged/, on recharge avec les tags restants
          // (ou on revient au blog si c'était le dernier tag).
          if (window.location.pathname.indexOf('/tagged/') !== -1) {
            window.location.href = self._taggedUrl();
            return;
          }
          self._syncPills();
        });
      });
    }

    /* ──────────────── Submit / Reset ──────────────── */

    _bindActions() {
      var self = this;
      Array.prototype.forEach.call(this.root.querySelectorAll('[data-submit]'), function (btn) {
        btn.addEventListener('click', function () { self._submit(); });
      });
      var reset = this.root.querySelector('[data-reset]');
      if (reset) reset.addEventListener('click', function () { self._reset(); });
    }

    _taggedUrl() {
      var handles = Array.prototype.map.call(
        this.root.querySelectorAll('[data-checkbox]:checked'),
        function (c) { return c.dataset.handle || c.value; }
      );
      return handles.length ? this.blogUrl + '/tagged/' + handles.join('+') : this.blogUrl;
    }

    _submit() {
      window.location.href = this._taggedUrl();
    }

    _reset() {
      var self = this;
      Array.prototype.forEach.call(this.root.querySelectorAll('[data-checkbox]'), function (cb) {
        cb.checked = false;
      });
      this.filters.forEach(function (f) { self._syncBadge(f); });
      this._syncPills();
      if (window.location.pathname.indexOf('/tagged/') !== -1) {
        window.location.href = this.blogUrl;
      }
    }

    /* ──────────────── Hydrate from Liquid current_tags ──────────────── */

    _hydrate() {
      var node = this.root.querySelector('[data-current-tags]');
      if (!node) return;
      var tags;
      try { tags = JSON.parse(node.textContent) || []; } catch (_) { return; }
      var self = this;
      tags.forEach(function (tag) {
        var cb = self.root.querySelector('[data-checkbox][value="' + self._attr(tag) + '"]');
        if (!cb) return;
        cb.checked = true;
        var f = cb.closest('[data-filter]');
        if (f) self._syncBadge(f);
      });
      this._syncPills();
    }

    /* ──────────────── Utils ──────────────── */

    _bindResize() {
      var self = this;
      var timer;
      window.addEventListener('resize', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          self._hideSugg();
          self._closeAll();
        }, 150);
      });
    }

    _esc(s) {
      return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }

    _attr(s) {
      return String(s).replace(/\\/g,'\\\\').replace(/"/g,'\\"');
    }
  }

  document.querySelectorAll('[data-search-cours]').forEach(function (el) {
    new SearchCours(el);
  });

})();


  } catch(e) { console.error(e); }
})();
})();
